<template>
  <div class="empty-info">
    <img class="empty-img" :src="empty" alt="" />
    <div>输入网址错误，找不到机构，请联系老师</div>
  </div>
</template>

<script>
import empty from '@/assets/course_empty.png'
export default {
  name: '404',
  data() {
    return {
      empty,
    }
  },
}
</script>

<style scoped>
.empty-info {
  display: flex;
  flex-direction: column;
  text-align: center;
  color: #666;
}
.empty-img {
  width: 300px;
  margin: 50px auto 30px auto;
}
</style>
